import HomePageContainer from './HomePageContainer';

export default HomePageContainer;